import ko from 'knockout'
import NoveltyDividend from '../../../Model/NoveltyDividend'
import { NoveltyDividendsViewModel } from './NoveltyDividendsViewModel'
import template from './novelty.dividends.tpl.html'

interface Params {
  noveltyDividends: ko.ObservableArray<NoveltyDividend>
}

if (!ko.components.isRegistered('novelty-dividends')) {
  ko.components.register('novelty-dividends', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new NoveltyDividendsViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
